import React, { useEffect } from 'react'
import { Outlet, useLocation } from 'react-router-dom'
import Header from '../components/Header'
import Footer from '../components/Footer'
import BreadCrumb from '../components/BreadCrumb'
import SideBar from '../components/SideBar'

const MainLayout = () => {
    const { pathname } = useLocation()
    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth',
        });
    }, [pathname])

    return (
        <main className='text-center'>
            <SideBar />
            <Header />
            <BreadCrumb />
            <Outlet />
            <Footer />
        </main>
    )
}

export default MainLayout